// lib/correlationId.ts
import { v4 as uuidv4 } from 'uuid';

let currentCorrelationId: string | null = null;

export const generateCorrelationId = (): string => {
  // `randomUUID` needs a secure context, so it is absent over plain http on a
  // LAN IP even though `window.crypto` itself is present — call it optionally
  // or the uuidv4 fallback never gets the chance to run.
  currentCorrelationId =
    typeof window !== 'undefined'
      ? window.crypto?.randomUUID?.() || uuidv4()
      : uuidv4();
  return currentCorrelationId;
};

export const getCurrentCorrelationId = (): string | null => {
  return currentCorrelationId;
};

export const setCorrelationId = (id: string): void => {
  currentCorrelationId = id;
};
